import { useDashboardWidgetsTransport } from "../routes/useDashboardWidgetsTransport"

export const useDashboardWidgets = (
  initialDashboardId?: string,
  options?: { fetchWidgets?: boolean },
) => useDashboardWidgetsTransport(initialDashboardId, options)
